// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 40px 80px;
}

.checkout-page h1 {
  font-size: 32px;
  margin-bottom: 32px;
}

.checkout-content {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 32px;
}

.checkout-form h2 {
  font-size: 24px;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-dark);
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid var(--border);
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.checkout-submit-btn {
  width: 100%;
  padding: 16px;
  font-size: 18px;
  margin-top: 8px;
}

.secure-notice {
  text-align: center;
  margin-top: 16px;
  color: var(--text-light);
  font-size: 14px;
}

.order-summary {
  position: sticky;
  top: 120px;
  height: fit-content;
  display: flex;
  flex-direction: column;
}

.order-summary h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.summary-items {
  width: 100%;
  border-bottom: 1px solid var(--border);
  padding-bottom: 16px;
  margin-bottom: 16px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  color: var(--text-dark);
  line-height: 1.5;
  gap: 16px;
}

.summary-item span:first-child {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 8px;
}

.summary-item span:last-child {
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.summary-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
  color: var(--primary-color);
  padding-top: 4px;
  gap: 16px;
}

.summary-total span:first-child {
  flex: 0 0 auto;
}

.summary-total span:last-child {
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
}

@media (max-width: 768px) {
  .checkout-page {
    padding: 16px 16px 60px;
  }

  .checkout-page h1 {
    font-size: 26px;
    margin-bottom: 24px;
  }

  .checkout-content {
    grid-template-columns: 1fr;
  }

  .order-summary {
    position: static;
    order: -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Checkout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".checkout-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px 40px 80px;\n}\n\n.checkout-page h1 {\n  font-size: 32px;\n  margin-bottom: 32px;\n}\n\n.checkout-content {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: 32px;\n}\n\n.checkout-form h2 {\n  font-size: 24px;\n  margin-bottom: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid var(--border);\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.checkout-submit-btn {\n  width: 100%;\n  padding: 16px;\n  font-size: 18px;\n  margin-top: 8px;\n}\n\n.secure-notice {\n  text-align: center;\n  margin-top: 16px;\n  color: var(--text-light);\n  font-size: 14px;\n}\n\n.order-summary {\n  position: sticky;\n  top: 120px;\n  height: fit-content;\n  display: flex;\n  flex-direction: column;\n}\n\n.order-summary h2 {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n.summary-items {\n  width: 100%;\n  border-bottom: 1px solid var(--border);\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n}\n\n.summary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 12px 0;\n  color: var(--text-dark);\n  line-height: 1.5;\n  gap: 16px;\n}\n\n.summary-item span:first-child {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding-right: 8px;\n}\n\n.summary-item span:last-child {\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.summary-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--primary-color);\n  padding-top: 4px;\n  gap: 16px;\n}\n\n.summary-total span:first-child {\n  flex: 0 0 auto;\n}\n\n.summary-total span:last-child {\n  white-space: nowrap;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n@media (max-width: 768px) {\n  .checkout-page {\n    padding: 16px 16px 60px;\n  }\n\n  .checkout-page h1 {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n\n  .checkout-content {\n    grid-template-columns: 1fr;\n  }\n\n  .order-summary {\n    position: static;\n    order: -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
